import React from 'react'
import styled from 'styled-components'

import Tooltip from 'components/Tooltip'
import { numberFormatter } from 'utils/numbers'
import formatCurrency from 'utils/formatCurrency'

const Grid = styled.div<{ backup?: boolean }>`
  display: grid;
  font-size: 13px;
  grid-gap: 5px 20px;
  grid-template-columns: 2fr 1fr 1fr;

  ${({ backup }) =>
    backup &&
    `
    margin-top: 20px;
  `}
  .text-ellipsis {
    max-width: 150px;
  }
`
const Row = ({
  awarded_type,
  awarded_volume,
  carrier,
  rate_price,
}: LaneProposal) => (
  <>
    <div className="text-ellipsis">{carrier?.name || carrier?.email}</div>
    <div className="text-center">
      {awarded_type === 'primary' ? numberFormatter(awarded_volume) : '-'}
    </div>
    <div className="text-right">{formatCurrency(rate_price)}</div>
  </>
)
export const AwardedCarriersCell = ({
  value,
  row,
}: {
  value: LaneProposal[]
  row: { id: string }
}) => {
  if (!value.length) {
    return '-'
  }
  const { primary, backup } = value.reduce<{
    all: Record<number, LaneProposal>
    backup: LaneProposal[]
    primary: LaneProposal[]
  }>(
    (acc, proposal) => {
      if (acc.all[proposal.id] || !proposal.awarded_type) {
        return acc
      }
      acc.all[proposal.id] = proposal
      return {
        ...acc,
        [proposal.awarded_type]: [...acc[proposal.awarded_type], proposal],
      }
    },
    { all: {}, primary: [], backup: [] }
  )
  return (
    <label data-tip data-for={`awardedCarriers-${row.id}`}>
      {primary.length > 0 && `${primary.length} Primary`}
      {primary.length > 0 && backup.length > 0 && `, `}
      {backup.length > 0 && `${backup.length} Backup`}

      <Tooltip id={`awardedCarriers-${row.id}`}>
        <Grid>
          <b>Primary</b>
          <b className="text-center">Vol.</b>
          <b className="text-right">Rate</b>
          {primary.map((proposal) => (
            <Row key={proposal.id} {...proposal} />
          ))}
        </Grid>
        {backup.length > 0 && (
          <Grid backup>
            <b>Backup</b>
            <b />
            <b />
            {backup.map((proposal) => (
              <Row key={proposal.id} {...proposal} />
            ))}
          </Grid>
        )}
      </Tooltip>
    </label>
  )
}
